var map = {
	"./ai.png": 423,
	"./computer_literacy.png": 424,
	"./ege-informatika-desk.png": 353,
	"./ege-informatika.png": 354,
	"./frontend.png": 425,
	"./game_design.png": 426,
	"./graphic_design.png": 427,
	"./math-desk.png": 355,
	"./math.png": 356,
	"./predprinimatelstvo.png": 428,
	"./programming_basics.png": 429,
	"./python.png": 430,
	"./scratch.png": 431,
	"./unity.png": 432,
	"./videoblogging.png": 433,
	"./web-razrabotka.png": 434
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 775;